import { render } from "./CropLimingFertilizationForm.vue?vue&type=template&id=13844076&scoped=true&ts=true"
import script from "./CropLimingFertilizationForm.vue?vue&type=script&lang=ts"
export * from "./CropLimingFertilizationForm.vue?vue&type=script&lang=ts"

import "./CropLimingFertilizationForm.vue?vue&type=style&index=0&id=13844076&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13844076"]])

export default __exports__